import moment from 'moment';

const noticeTypeToColName = {
  1: 'statePushId',
  2: 'stateEmailId',
  3: 'stateSmsId',
  4: 'statePhoneId',
};

const STATUS_PHONE = {
  0: 'новый',
  1: 'в обработке',
  2: 'завершен',
};
const STATUS_PUSH = {
  0: 'не отправлено',
  1: 'отправлено',
};

const STATUS_EMAIL = {
  1: 'отправлено',
  2: 'в обработке',
  3: 'не отправлено',
};

const STATUS_SMS = {
  0: 'не отправлено',
  1: 'отправлено',
};

const specialColumns = (noticeId, noticeTypeView, debtorStates) => {
  if (noticeId) {
    return [
      {
        title: 'Статус',
        dataIndex: noticeTypeToColName[noticeTypeView],
        sorter: (a, b) => {
          if (a.state < b.state) {
            return -1;
          }
          if (a.state === b.state) {
            return 0;
          }
          if (a.state > b.state) {
            return 1;
          }
        },
        render: (stateId) => {
          switch (noticeTypeView) {
            case 1:
              return STATUS_PUSH[stateId];
            case 2:
              return STATUS_EMAIL[stateId];
            case 3:
              return STATUS_SMS[stateId];
            case 4:
              return STATUS_PHONE[stateId];
            default:
              return 'нет данных';
          }
        },
      },
    ];
  } else {
    return [
      {
        title: 'Долг',
        dataIndex: 'debt',
        sorter: (a, b) => {
          return Number(a.debt) - Number(b.debt);
        },
      },
      {
        title: 'Дата',
        dataIndex: 'dateOnset',
        sorter: (a, b) => {
          const aDate = moment(a.dateOnset, 'DD.MM.YYYY');
          const bDate = moment(b.dateOnset, 'DD.MM.YYYY');
          if (aDate.isAfter(bDate)) {
            return -1;
          }
          if (bDate.isAfter(aDate)) {
            return 1;
          }
          if (aDate.isSame(bDate)) {
            return 0;
          }
        },
      },
    ];
  }
};
export default specialColumns;
